module.exports = " <div class=conText _v-241dc240=\"\"> <div class=backcolor _v-241dc240=\"\"> <div _v-241dc240=\"\"> <h2 class=h2css _v-241dc240=\"\">联系我们 &nbsp;&nbsp;<span style=font-family:cursive;font-size:19px _v-241dc240=\"\">CONTACT US</span> </h2> </div> <div v-html=link.content.content style=\"padding: 10px\" _v-241dc240=\"\"></div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-241dc240!./~/vue-loader/lib/selector.js?type=template&index=0!./src/wuyan/tellOur.vue
// module id = 202
// module chunks = 1